import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { PMS_API_URLS } from "../_constants/PMS_API_URLS";

export const PMSLodgifyService = {
    listProperties,
}

function listProperties(uid: string) {
    return ServiceHelper.getRequest(
        PMS_API_URLS.LODGIFY_PROPERTIES,
        {
            uid: uid
        }
    );
}